// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"bd2e835d","840":"0afed059"}[chunkId] + ".chunk.css";
};